import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
import { BASE_URL } from "../../../api-factory";
import Loader from "../../../../../../presentationals/Loader/Loader.component";
import { getSheetUrl } from '../../CommunityActionCreator'

const GoogleSheets = ({rowData}) => {


    const [loaderState, setLoaderState] = useState(false)
    const [googleLoginurl, setgoogleLoginurl] = useState()
    // const location = useLocation();
    const [loanId, setLoanId] = useState('')
    const [userId, setuserId] = useState('')
    const [applicationId, setapplicationId] = useState('')
    const [iframeUrl, setIframUrl] = useState('')
    const [showLogin, setShowLogin] = useState(false)


    useEffect(() => {
        if (rowData) {
            setLoanId(rowData.loanId)
            setuserId(rowData.userId)
            setapplicationId(rowData.applicationId)


        }
        isLoginCheck()
        googleHandler()
    }, [])
    const isLoginCheck = () => {
        setLoaderState(true)
        fetch(BASE_URL + '/getGoogleAuthDetail')
            .then(res => res.json())
            .then(jsonRes => {
                console.log(jsonRes)
                if (jsonRes.data && jsonRes.data.valid === true) {
                    if (rowData.loanId) {
                        getSheetUrl(rowData.loanId, rowData.applicationId, rowData.userId, callBack => {
                            console.log(callBack, 'callBack')
                            setIframUrl(callBack.data)
                            setLoaderState(false)

                        })
                    }
                } else {
                    setShowLogin(true)
                    setLoaderState(false)

                }

            });
    }
    const googleHandler = () => {
        const componentRef = this;
        if (navigator.onLine) {
            fetch(BASE_URL + '/googleAuthUrl')
                .then(res => res.json())
                .then(jsonRes => {
                    if (jsonRes != null && jsonRes.status != 'exist') {
                        setgoogleLoginurl(jsonRes.data)

                    }
                });
        } else {
            alert("please check your internet Connection!")
        }
    }

    const applyNowHandler = () => {
        window.open(googleLoginurl)

    }
    const _messageFromChildWindowCallback = ({ data }) => {
        if (typeof data === 'string') {
            if (data.includes("{")) {
                if (loanId) {
                    getSheetUrl(loanId, applicationId, userId, callBack => {
                        console.log(callBack, 'callBack')
                        setIframUrl(callBack.data)
                    })
                }
            }

        }
    }


    return (
        <div className='container mt-3'>
            {window.addEventListener('message', _messageFromChildWindowCallback, false)
            }
            {loaderState ?
                <Loader />
                : null}
            {showLogin ?
                <div style={{ marginTop: '190px', cursor: 'pointer' }}>
                    <div className="text-center">
                        <a
                            // href={googleLoginUrl}
                            // target='_blank'
                            className='google google-btn-new '
                            onClick={e => applyNowHandler()}
                        >
                            <i className='fa fa-google fa-fw'></i> Login with Google
                        </a>
                    </div>
                </div>
                : ""}
            {iframeUrl ?
                <div className="col-sm-12 col-xs-12">
                    <iframe width='100%' height='700px' src={iframeUrl} />

                    {/* <iframe width='100%' height='700px' src='https://docs.google.com/spreadsheets/d/1_jVxI7LFfZ6f-bcwRoymOoCe8IMKG6eeJKm8FtP6bxo/edit#gid=0'/> */}
                </div>
                : ""}

        </div>
    )

}
export default GoogleSheets